// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-stepper[data-v-1d7e05cc]{box-shadow:none}", ""]);
// Exports
module.exports = exports;
